/**
 * Route for `igaming-deposit-stream`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingDepositStreamPage } from "../features/igaming-deposit-stream/IgamingDepositStreamPage";

export const igamingDepositStreamRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-deposit-stream",
	component: IgamingDepositStreamPage,
});

export default igamingDepositStreamRoute;
